import { Component, Input, OnInit } from '@angular/core';
import { FormControl } from "@angular/forms";
import { GenericFormService } from '../service/generic-form.service';
import { FieldModel } from '../model/field.model';
import { Subject, takeUntil } from 'rxjs';

@Component({
	selector: 'cv-dropdown-field',
	templateUrl: './dropdown-field.component.html',
	styleUrls: ['./dropdown-field.component.scss'],
})
export class DropdownFieldComponent implements OnInit {
	@Input() fieldOptions: any;
	@Input() control: FormControl;
	@Input() field: FieldModel;
	@Input() value: any;
	options: any;
	private atComponentDestroy: Subject<any> = new Subject<any>();

	constructor(
		private formService: GenericFormService
	) { }

	ngOnInit(): void {
		this.options = this.field.options;

		if(this.field.disabled){
			this.control.disable();
		}
	}

	/**
	 * Trigger the field onChange
	 *
	 * @param $event
	 * @param field
	 * @param row
	 */
	onChange($event: any): void {
		if ('UIEvents' in this.field && this.field.UIEvents.onChange) {
			this.formService.onChangeOptions$.next({
				field: this.field,
				fieldOptions: this.fieldOptions,
				event: $event
			});
		}
	}

	/**
	 * Trigger the field onSelect
	 *
	 * @param $event
	 * @param field
	 * @param row
	 */
	onSelect($event: any): void {
		if (this.field.UIEvents.onSelect) {
			this.formService.onSelectOptions$.next({
				field: this.field,
				event: $event
			});
		}
	}

	/**
	 * Trigger the field onSelect
	 *
	 * @param $event
	 */
	filterOptions($event: any): void {
		this.formService.onSelectOptions$.next({
			field: this.field,
			event: {}
		});

		this.formService
			.getDataByUrl(this.field.UIOptions?.Url, this.field.UIOptions.FilterName, $event.query)
			.pipe(takeUntil(this.atComponentDestroy))
			.subscribe(result => {
				let options = [];
				if (result) {
					if(Array.isArray(result)){
						options = result.map((o: any) => {
							const id = this.field['UIOptions']['OptionsMapper'] ? o[this.field['UIOptions']['OptionsMapper']['id']] : o['id'];
							const name = this.field['UIOptions']['OptionsMapper'] ? o[this.field['UIOptions']['OptionsMapper']['name']] : o['name']
							return {
								id: id,
								name: name
							};
						});
					}else {
						for(const key in result) {
							options.push({
								value: key,
								label: result[key]
							})
						}
					}
				}
				this.field.options = options;
			});
	}

}
